import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRedirectArrow: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="redirect-arrow"><path d="M12 21V7.875C12 5.59683 10.1532 3.75 7.875 3.75C5.59683 3.75 3.75 5.59683 3.75 7.875C3.75 10.1532 5.59683 12 7.875 12H20" stroke="currentColor" strokeWidth="1.5"/><path d="M16.25 8L20.25 12L16.25 16" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconRedirectArrow;
